module.exports = __webpack_public_path__ + "static/media/crossChip.e83339b9.svg";